/**
 * How many rows a list screen asks for.
 *
 * One number rather than a literal repeated in four files, because the value is
 * a product decision - it is what the reader sees before they have to press
 * anything - and four copies of it drift the first time somebody tunes one
 * screen. The API's own default is 25 and its cap is 100 (`paginationQuery` in
 * `@taskiq/shared`); this is the console's answer, sent explicitly so the screen
 * shows what it asked for rather than whatever the server currently defaults to.
 *
 * Ten fits a laptop viewport without the table becoming the scroll, and keeps
 * the response small enough that paging feels instant on a site depot's
 * connection. Visits already used it; the rest were on 25 and disagreeing.
 */
export const LIST_PAGE_SIZE = 10;

/**
 * The schedule's agenda view.
 *
 * Same number, different reason: the agenda groups rows under day headings, so
 * a page is really "ten appointments and the two or three days they fall on".
 * Larger and the day the reader is looking for is below the fold anyway; the
 * calendar views are the ones that want a whole window at once.
 */
export const AGENDA_PAGE_SIZE = 10;
